<template>
    <section class="py-20 bg-gray-950">
        <div class="container">
            <div class="text-center xl:space-y-6 lg:space-y-4 space-y-6">
                <h2 class="text-gray-100 xl:text-title-xl lg:text-title-lg text-title-md font-bold">
                    {{ $t("landingComponents_apiAccess_title") }}
                </h2>

                <p class="text-gray-700 xl:text-title-md text-body-lg">
                    {{ $t("landingComponents_apiAccess_desc") }}
                </p>

                <div class="flex flex-wrap items-center justify-center gap-2">
                    <NuxtLinkLocale
                        :id="handleId + '-api-book-demo'"
                        to="https://calendly.com/aihomedesignteam/30min"
                        target="_blank"
                    >
                        <AppButton :block="useDevice().isMobile" color="brand">
                            {{ $t("landingComponents_apiAccess_bookDemo") }}
                        </AppButton>
                    </NuxtLinkLocale>
                    <NuxtLinkLocale to="/pricing" :id="handleId + '-api-pricing'">
                        <AppButton variant="outlined" :block="useDevice().isMobile">
                            {{ $t("landingComponents_apiAccess_discoverPricing") }}
                        </AppButton>
                    </NuxtLinkLocale>
                    <NuxtLinkLocale :id="handleId + '-api-learn-more'" to="/b2b">
                        <AppButton variant="ghost" :block="useDevice().isMobile">
                            <div class="flex space-x-1 items-center">
                                {{ $t("global_learnMore") }}
                                <Icon class="size-6" name="tabler:chevron-right" />
                            </div>
                        </AppButton>
                    </NuxtLinkLocale>
                </div>
            </div>

            <div class="flex mt-10 justify-center xl:flex-row flex-col gap-8">
                <div
                    v-for="cardItem in items"
                    :key="cardItem.title"
                    class="h-[280px] min-w-[354px] bg-gray-900 rounded-2xl overflow-hidden relative"
                >
                    <div class="lg:pb-6 pb-10 p-6 text-wrap">
                        <h3 class="text-gray-100 lg:text-title-md text-title-sm font-bold lg:mb-4 mb-2">
                            {{ cardItem.title }}
                        </h3>
                        <p class="text-gray-500 lg:text-body-lg text-body-md">{{ cardItem.subtitle }}</p>
                    </div>
                    <!-- ms-auto h-1/2 absolute bottom-0 right-0 -->
                    <div class="ms-auto w-3/4 h-1/2 absolute bottom-0 right-0">
                        <NuxtImg
                            class="w-full h-full object-cover rounded-ss-2xl"
                            loading="lazy"
                            provider="imgProvider"
                            :src="cardItem.img.src"
                            :alt="cardItem.title"
                        />
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
import type { IHorizontalServiceIntro } from "~/types/components/landings.type";

const { t } = useI18n();

const items: IHorizontalServiceIntro[] = [
    {
        img: { src: "/Landings/general/EnterpriseSection_01.png" },
        title: t("landingComponents_apiAccess_title_1"),
        subtitle: t("landingComponents_apiAccess_subtitle_1"),
    },
    {
        img: { src: "/Landings/general/EnterpriseSection_02.png" },
        title: t("landingComponents_apiAccess_title_2"),
        subtitle: t("landingComponents_apiAccess_subtitle_2"),
    },
    {
        img: { src: "/Landings/general/EnterpriseSection_03.png" },
        title: t("landingComponents_apiAccess_title_3"),
        subtitle: t("landingComponents_apiAccess_subtitle_3"),
    },
];
const handleId = computed(() => {
    if (useRoute().fullPath === "/") return "homepage";
    if (useRoute().fullPath.includes("virtual-staging")) return "virtualstaging";
    if (useRoute().fullPath.includes("image-enhancement")) return "imageenhancement";
    if (useRoute().fullPath.includes("day-to-dusk")) return "daytodusk";
    if (useRoute().fullPath.includes("item-removal")) return "itemremoval";
    if (useRoute().fullPath.includes("photo-editing")) return "photoediting";
});
</script>
